export default __webpack_public_path__ + "static/8-overseas-destinations-less-than-an-8hr-flight-away-d18a939671eae079cfdfe1c2459c872f.jpg";